import type { ReactNode } from 'react';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import ScrollToHash from '@/components/feature/ScrollToHash';

export default function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <ScrollToHash />
      <SiteHeader />
      <main className="flex-1 w-full">{children}</main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}